export default "__VITE_ASSET__BUL$cX4a__"